module.exports = __webpack_public_path__ + "static/media/medium-tornillos.43e5ceaf.png";